import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { HierarchyItem } from '../../models/hierarchyItem';

@Component({
  selector: 'hierarchy-item',
  templateUrl: './hierarchy-item.component.html',
  styleUrls: ['./hierarchy-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HierarchyItemComponent {
  @Input() item: HierarchyItem;
  @Input() isCurrent: boolean = false;
  @Input() hasChild: boolean = true;
  @Input() isPopUp: boolean = false;
  @Input() smallWidth: boolean;
  @Input() set isSelected(val: boolean) {
    if (val) this.onSelectedItem();
  }
  @Output() selectedItem: EventEmitter<void> = new EventEmitter<void>();

  onSelectedItem(): void {
    this.selectedItem.emit();
  }
}
